
import { Component, Vue, Watch } from 'vue-property-decorator'
import eventBus from '@/plugins/eventBus'
import { UserModel } from '@/store/models/UserModel'
import STextField from '@/components/STextField.vue'
import { CredentialsError } from '@/plugins/popups'
import SButton from '@/components/SButton.vue'

import { fbConnector, gmailConnector, googleAnalytics } from '@/plugins/globals'

let facebookConnector = new fbConnector()
facebookConnector.initFB()

let gm = new gmailConnector()
gm.initGmail()

let ga = new googleAnalytics()
ga.gaInit()

@Component({
  components: { STextField, SButton },
})
export default class LoginModal extends Vue {
  user: UserModel = UserModel.getInstance()
  error: any = {}
  userLogged: any = {}
  disableLoginBtn: boolean = false

  mounted() {
    eventBus.$on('login_modal:open', () => {
      this.$modal.show('login')
    })
    eventBus.$on(`error`, (error: object) => {
      this.error = error
      if (this.error.status === 401) {
        CredentialsError()
        return false
      }
    })
    eventBus.$on('user:logged', (userLogged: any) => {
      this.userLogged = userLogged
    })
  }
  credentialsLogin() {
    this.disableLoginBtn = true
    this.user.loginWithCredentials(
      () => {
        this.disableLoginBtn = false
      },
      () => {
        this.disableLoginBtn = false
      }
    )
  }
  async facebookLogin() {
    await this.user.loginWithFacebook(() => {
      this.disableLoginBtn = false
    })
    this.$modal.hide('login')
  }
  async gmailLogin() {
    await this.user.loginWithGmail(() => {
      this.disableLoginBtn = false
    })
    this.$modal.hide('login')
  }
  registerModal() {
    this.$modal.hide('login')
    this.$modal.show('register')
  }
  @Watch('userLogged')
  onUserLoggedChange() {
    this.$modal.hide('login')
  }
}
